import React from 'react'
import ContainerLayout from '../../../components/container-layout/ContainerLayout'
import StateComponents from '../../../components/state-component/StateComponents'
import TableCustom from '../../../components/table/tableCustom'
import { debouncedApiCall, getBaseApi, handleTypingNumber } from '../../../utils/app.utils'
import ManageState from './manageState'
import ModalCustom from '../../../components/modal/ModalCustom'
import { useTranslation } from 'react-i18next'
import ModalMedia from '../../cms-website/media/modal-media/ModalMedia'
import { Box, IconButton, Typography } from '@mui/material'
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
type Props = {}

const CollaborationNetwork: React.FC<Props> = ({ }: Props) => {
    const { t } = useTranslation();
    const {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        showModal,
        handleCloseModal,
        form,
        set_form,
        handleSubmitForm,
        setShowModal,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,
        id_media_file,
        set_id_media_file,
        showModalMedia,
        setShowModalMedia,
        media_file_path,
        set_media_file_path,
        GetFile,
        checkPermit
    } = ManageState()
    const base_image_url = getBaseApi()


    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("เครือข่ายความร่วมมือ")}
                hidden_sub_title
                // navigateContent={
                //     <NavigateListCustom
                //         navigateData={[
                //             {
                //                 key: "complaintSubmit",
                //                 name: t("COMPLAINTS_COMPLAINT_SYSTEM"),
                //                 disabled_match: true,
                //                 pathName: ""
                //             },
                //             {
                //                 key: "complaintSubmit",
                //                 name: t("COMPLAINTS_MANAGE_CATEGORY"),
                //                 pathName: routeName.cms.complaintsType
                //             },
                //         ]}
                //     />
                // }
                // buttonContent={
                //     <ContainerButton
                //         justifyContent='flex-end'
                //         buttonData={[
                //             {
                //                 buttonProps: {
                //                     onClick: handleDownloadReport
                //                 },
                //                 key: "DOWNLOAD_CSV",
                //                 label: t("COMPLAINTS_DOWNLOAD_CSV"),
                //                 seq: 1,
                //                 type: "DOWNLOAD_CSV"
                //             }
                //         ]}
                //     />
                // }
                content={
                    <div className='w-full'>

                        <StateComponents
                            otherProps={{ spacing: 2 }}
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 4
                                    },
                                    fieldProps: {
                                        placeholder: t("ค้นหา ชื่อ"),
                                        onChange: (e) => debouncedApiCall({ setItem: setKeyword, searchItem: e.target.value })
                                    }
                                },
                                {
                                    seq: 2,
                                    type: "DATE_RANGE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        onchange: handleChangeDateRange,
                                        value: date_range || [],
                                        onClear: handleClearDateRange,
                                        allowClear: true,
                                        placeholder: t("ช่วงวันที่")
                                    }
                                },
                                {
                                    type: "COMPONENT",
                                    seq: 3,
                                    fieldProps: {
                                        element: <></>
                                    },
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    }
                                },
                                {
                                    seq: 4,
                                    type: "BUTTON",
                                    gridProps: {
                                        xs: 6,
                                        md: 2
                                    },
                                    hidden: !checkPermit.isCreated,
                                    fieldProps: {
                                        justifyContent: "flex-end",
                                        buttonData: [
                                            {
                                                seq: 1,
                                                key: "ADD2",
                                                label: t("เพิ่มเครือข่ายความร่วมมือ"),
                                                buttonProps: {
                                                    onClick: () => {
                                                        setShowModal("ADD")
                                                    },
                                                },
                                                type: "ADD2"
                                            }
                                        ]
                                    }
                                }
                            ]}
                        />

                        <section className='w-full mt-4'>
                            <TableCustom
                                tableMinWidth={1440}
                                tableFixedWidth
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy={sortBy}
                                sortType={sortType}
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={data?.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={handleRequestSort}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        </section>
                    </div>
                }
            />

            {showModal !== '' && (
                <ModalCustom
                    open
                    title={showModal === 'ADD' ? t("เพิ่มเครือข่ายความร่วมมือ") : t("ข้อมูลเครือข่ายความร่วมมือ")}
                    subTitle={t("กรุณาระบุข้อมูลให้ครบถ้วนก่อนการยืนยัน")}
                    onClose={handleCloseModal}
                    containerButton={{
                        disabled_submit: !form.collaboration_network_name,
                        hidden_submit: showModal === 'VIEW',
                        onClose: handleCloseModal,
                        onSubmit: () => handleSubmitForm()
                    }}
                    component={
                        <div className='w-full'>
                            <StateComponents
                                disabledAllField={showModal === 'VIEW'}
                                otherProps={{ spacing: 2 }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            heading: t("ลำดับการแสดงผล"),
                                            required: true,
                                            value: form.collaboration_network_seq,
                                            onChange: (e) => set_form((prev: any) => ({ ...prev, collaboration_network_seq: +e.target.value })),
                                            onkeypress: handleTypingNumber
                                        }
                                    },
                                    {
                                        seq: 2,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            heading: t("ชื่อเครือข่ายความร่วมมือ"),
                                            required: true,
                                            value: form.collaboration_network_name,
                                            onChange: (e) => set_form((prev: any) => ({ ...prev, collaboration_network_name: e.target.value }))
                                        }
                                    },
                                    {
                                        seq: 3,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            heading: t("ลิงก์เชื่อมโยง"),
                                            required: true,
                                            value: form.collaboration_network_link,
                                            onChange: (e) => set_form((prev: any) => ({ ...prev, collaboration_network_link: e.target.value }))
                                        }
                                    },
                                ]}
                            />
                            <Box sx={{ margin: '10px' }}>
                                <Typography>logo</Typography>
                                <Box sx={{ width: '100%', marginTop: "5px", borderRadius: "8px", border: "1px dashed #DDE1EB", padding: '10px', maxHeight: "250px", position: "relative", cursor: "pointer" }} onClick={() => setShowModalMedia(true)}>
                                    <img src={media_file_path ? base_image_url + '/' + media_file_path : 'https://placehold.co/600x400?text=No+Img'} style={{ objectFit: 'contain', objectPosition: "center", width: "100%", height: "220px" }} />
                                    <IconButton onClick={() => set_media_file_path('')} sx={{ position: "absolute", bottom: '10px', right: "10px" }}>
                                        <HighlightOffIcon />
                                    </IconButton>
                                </Box>
                            </Box>
                        </div>
                    }
                />
            )}
            <ModalMedia
                handleClose={() => setShowModalMedia(false)}
                open={showModalMedia}
                id_media_file={null}
                title=''
                onSubmitLocalFile={(id_media_file) => {
                    set_id_media_file(id_media_file);
                    // setShowModalMedia(false)

                }}
                onSubmitMediaFile={(_, id_media_file, media_file_path, media_file_name) => {
                    console.log(id_media_file);
                    set_id_media_file(id_media_file)

                }
                }
                // onSubmitMediaFileMultiple={(data) => {
                //     set_id_media_file((prev) => ([...prev, ...data]));
                // }}
                onSelectMediaFile={(_, id_media_file, media_file_path, media_file_name) => {
                    if (id_media_file) {
                        set_id_media_file(id_media_file)
                        GetFile(id_media_file)
                        setShowModalMedia(false)

                    }
                    console.log(media_file_path, id_media_file);
                    // set_media_file_path(`${media_file_path}${media_file_name}`)
                }}
                multiple={false}
            />
        </div>
    )
}

export default CollaborationNetwork